module.exports = __webpack_public_path__ + "static/img/smt_offiaccount.2913a406.png";